// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageSquare01Icon from "@/assets/icons/message-square-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageSquare01IconProps = Omit<IconProps, "name">;

export function MessageSquare01Icon(props: MessageSquare01IconProps): React.ReactNode {
  return <Icon name={messageSquare01Icon} {...props} />;
}
